/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { EstimatingTakeOffParamsTabBusinessService } from '../../resources/estimating-take-off-params-tab-business.service';
import { EstimatingTakeOffParamDetailsDialogComponent } from './estimating-take-off-param-details-dialog.component';

export const estimatingTakeOffParamDetailsDialog = createDialogRoute({
  component: EstimatingTakeOffParamDetailsDialogComponent,
  init: {
    service: EstimatingTakeOffParamsTabBusinessService,
    selector: 'initDialogView',
  },
});
